import { List } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import { useTranslation } from '@frontend/i18n';
import { useAudienceTray } from '../providers/audience-tray-provider';
import { InteractiveListItem } from './interactive-list-item';

type Props = {
  cancelRenameList: () => void;
  finishRenameList: (updatedName: string) => Promise<void>;
  list: List;
};

export const RenameListItem = ({ list, cancelRenameList, finishRenameList }: Props) => {
  const { t } = useTranslation('bulk-messaging');
  const { trackingIdPrefix } = useAudienceTray();

  return (
    <InteractiveListItem
      actionText={t('Rename List')}
      cancelTrackingId={`${trackingIdPrefix}-rename-list-item-cancel-btn`}
      list={list}
      onCancel={cancelRenameList}
      onSave={finishRenameList}
      saveTrackingId={`${trackingIdPrefix}-rename-list-item-save-btn`}
    />
  );
};
